export default {"src":"/_next/static/media/ic-pdf.84f4935e.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};